export const ACTIVE = 'ACTIVE';
export const INACTIVE = 'INACTIVE';
export const COMPLETED = 'COMPLETED';
export const PRICE = 'PRICE';
export const WIDGET = 'WIDGET';
export const originalVariantColors = {
  light: '#08875D',
  dark: '#EDFDF8',
};
